var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 15.3582H10.8332L7.12483 17.8249C6.57483 18.1916 5.83317 17.7999 5.83317 17.1332V15.3582C3.33317 15.3582 1.6665 13.6916 1.6665 11.1916V6.19157C1.6665 3.69157 3.33317 2.0249 5.83317 2.0249H14.1665C16.6665 2.0249 18.3332 3.69157 18.3332 6.19157V11.1916C18.3332 13.6916 16.6665 15.3582 14.1665 15.3582Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.0916C9.65834 10.0916 9.37501 9.80822 9.37501 9.46655V9.29159C9.37501 8.32492 10.0833 7.84991 10.35 7.66658C10.6583 7.45824 10.7583 7.31658 10.7583 7.09991C10.7583 6.68325 10.4167 6.34155 10 6.34155C9.58334 6.34155 9.2417 6.68325 9.2417 7.09991C9.2417 7.44158 8.95837 7.72491 8.6167 7.72491C8.27503 7.72491 7.9917 7.44158 7.9917 7.09991C7.9917 5.99158 8.89168 5.09155 10 5.09155C11.1083 5.09155 12.0083 5.99158 12.0083 7.09991C12.0083 8.04991 11.3084 8.5249 11.05 8.6999C10.725 8.91657 10.625 9.05825 10.625 9.29159V9.46655C10.625 9.81655 10.3417 10.0916 10 10.0916Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.1667C9.65 12.1667 9.375 11.8834 9.375 11.5417C9.375 11.2001 9.65833 10.9167 10 10.9167C10.3417 10.9167 10.625 11.2001 10.625 11.5417C10.625 11.8834 10.35 12.1667 10 12.1667Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.5dac07fd0099538da4ab03dab1d74ccc.svg";
export { ForwardRef as ReactComponent };